import '.il{display:inline-block;}.ssr-plugin'
import '.im{margin-top:1.5rem;}.ssr-plugin'
import '.aw{font-size:0.875rem;}.ssr-plugin'
import '.in{color:var(--palette-blue-500);}.ssr-plugin'
import '.h5{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="il im aw in h5"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
